module.exports = __webpack_public_path__ + "static/media/buddha.2889495d.jpg";